<template>
    <div class="opera-citySearch">
        <topNav :title="$t('configeHotel_title')"
                @leftClick="cancleSelect" selfMethod="1"></topNav>
        <div class="fangt_top">
            <div class="search">
                <i class="iconfont icon-sousuo"></i>
                <input type="text" id='searchInput' v-model='searchText' name="" :placeholder="$t('hotelName')">
                <div class="cleartext" @click="searchText='';getcityrm();" v-show="searchText != ''">
                    <i class="iconfont icon-cuowu"></i>
                </div>
            </div>
            <div class="searct_btn" @click='gotPosition'>{{$t('search')}}</div>

        </div>
        <div class="filterContent">
            <mt-checklist align="left" v-model="value" :options="checkOption"></mt-checklist>

        </div>
        <div class="staI">
          <div class="btn"
               @click='cancleSelect'>{{$t('cancel')}}</div>
          <div class="btn"
               @click='saveSelect'>{{$t('save')}}</div>
        </div>
    </div>
</template>

<script>

// mint-cell
import { Toast, Checklist } from 'mint-ui';
export default {
    data() {
        return {
            value: [],
            checkOption: [],
            searchText: '',
            listNumber: [],
        }
    },
    mounted() {
        this.getcityrm();
        this.showFilter();
    },
    methods: {
        //获取所有的酒店
        getcityrm() {
            // document.querySelector('.filterContent>.mint-checklist').classList.remove('hide-list')
            this.clearhide()
            this.$http.post('/mobilepmsapi/reception/getSameCityInfo', { searchText: this.searchText }).then(res => {
                if (res.data.result == 0) {
                    this.cityrm = res.data.retVal;
                    _.forEach(this.cityrm, (el, index) => {
                        this.$set(el, 'unfold', false);
                    })
                }
                else {
                    this.msg(res.data.msg);
                }
            })
        },
        //根据文本框搜索
        gotPosition() {
            this.clearhide()
            document.querySelector('.citySearch>.filterContent>.mint-checklist').classList.add("hide-list");
            let arr = document.querySelectorAll(".mint-checkbox-label");
            let indeNumber = this.value.length;

            for (var i = 0; i < indeNumber; i++) {
                if (arr[i].innerHTML.match(this.searchText)) {
                    document.querySelectorAll('.citySearch>.filterContent>.mint-checklist>.mint-cell')[i].classList.add('hide-cell');
                }
            }
        },
        //清除添加的类
        clearhide(){
            document.querySelector('.filterContent>.mint-checklist').classList.remove('hide-list')
            let arr=document.querySelectorAll('.filterContent>.mint-checklist>.hide-cell');
            for( var i=0;i<arr.length;i++){
                arr[i].classList.remove('hide-cell');
            }
        },
        //显示存在的酒店
        showFilter() {
            this.filter = true;
            this.checkOption = [];
            this.value = [];
            this.$http.get('/mobilepmsapi/sys/getSameCityMyView').then(res => {
                if (res.data.result == 0) {
                    this.listNumber = res.data.result;
                    _.forEach(res.data.retVal, (el, index) => {
                        this.checkOption.push(_.merge({}, { label: el.descript, value: el.id }));
                        if (el.selected) {
                            this.value.push(el.id)
                        }
                    })
                }
            })
        },
        //保存选中的酒店
        saveSelect() {
            this.$http.post('/mobilepmsapi/sys/updateMySameCityHotel', this.value).then(res => {
                if (res.data.result == 0) {
                    this.getcityrm();
                    this.$router.push('/opera/cityState');
                } else {
                  this.msg(this.$t("msg_save_fail"));
                }
            })
        },
        cancleSelect() {
            this.$router.push('/opera/cityState');
        },
        msg(msg) {
			Toast({
				message: msg,
				position: 'bottom',
				duration: 3000
			});
			return false;
		},
    }
}
</script>

<style lang='less'>
.opera-citySearch {
    background-color: #F6F8F9;
    .fangt_top {
        height: 1.26666667rem;
        width: 10rem;
        background: #fff;
        padding: .18666667rem 0;
        box-sizing: border-box;
        position: absolute;
        z-index: 1001;
        .search {
            margin-left: .34666667rem;
            border-radius: .44rem;
            width: 80%;
            float: left;
            height: 0.85333333rem;
            background-color: #f7f8fa;
            padding: 0 .26666667rem;
            overflow: hidden;
            box-sizing: border-box;
            i.icon-sousuo {
                vertical-align: bottom;
                font-size: 0.42666667rem;
                color: #ccc;
                line-height: .89333333rem;
            }
            input {
                padding-left: .2rem;
                width: 6rem;
                vertical-align: middle;
                margin-bottom: .13333rem;
                height: .62666667rem;
                background-color: #f7f8fa;
                outline: 0;
                border: 0;
            }
            .cleartext {
                float: right;
                i.icon-cuowu {
                    line-height: 0.3rem;
                    background-color: #c3c3c3;
                    border-radius: 50%;
                    font-size: 0.32rem;
                    text-align: center;
                    color: #fff;
                    padding: 0.13333333rem;
                    margin-top: 0.13333333rem;
                    -webkit-transform-origin-x: 0;
                    transform: scale(0.6);
                    -webkit-transform: scale(0.6);
                    width: 0.32rem;
                    display: inline-block;
                }
            }
        }
        .searct_btn {
            // width: 1.73333333rem;
            box-sizing: border-box;
            text-align: left;
            float: left;
            height: 100%;
            font-size: .32rem;
            line-height: .89333333rem;
            color: #5b5b5b;
            padding-left: .33333333rem;
        }
        .line {
            float: left;
            width: .02666667rem;
            height: .53333333rem;
            background-color: #ccc;
            margin-top: .21333333rem;
        }

        .filter {
            width: 1.86666667rem;
            float: left;
            font-size: .37333333rem;
            line-height: .89333333rem;
            text-align: right;
            box-sizing: border-box;
            color: #5b5b5b;
            .iconfont {
                display: inline-block;
                margin-left: .13333333rem;
                font-size: 12px;
            }
        }
    }
    .filterContent {
        width: 100%;
        overflow: auto;
        margin-top: 1.5rem;
        .mint-checklist {
            padding-bottom: 45px;
            &.hide-list {
                >a.mint-cell {
                    display: none;
                }
            }
            .mint-checklist-title {
                display: none;
            }
            .mint-cell {
                min-height: 40px;
                height: 40px;
                position: static;
                &:nth-of-type(2n) {
                    background-color: #f5f5f5;
                }
                .mint-checkbox-core {
                    border-radius: 0;
                    height: 16px;
                    width: 16px;
                }
                &.hide-cell{
                    display: block !important;
                }
            }
            .mint-checkbox-input:checked+.mint-checkbox-core {
                background-color: #fff;
                border-color: #ddd;
            }
            .mint-checkbox-input:checked+.mint-checkbox-core::after {
                border-color: #F89635;
            }
            .mint-checkbox-core::after {
                top: 2px;
                left: 5px;
            }
            .mint-checkbox-label {
                margin-left: 20px;
                font-size: 12px;
                color: #333;
            }
            .mint-cell-wrapper {
                background-image: none;
            }
        }
    }
    .staI {
        position: fixed;
        bottom: 0;
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: 16px;
        line-height: 45px;
        height: 45px;
        background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);
        .btn {
            float: left;
            width: 50%;
            text-align: center;
            color: #fff;
            height: 15px;
            font-size: 15px;
            line-height: 15px;
            margin-top: 15px;
            box-sizing: border-box;
            border-right: 1px solid rgba(255, 255, 255, 0.5);
        }
    } // .cityState .topHeader .mint-header{
    //     z-index: 2000;
    // }
}
</style>



// WEBPACK FOOTER //
// ConfigeHotel.vue?83aa69a0